import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ChainsIcon } from 'assets/icons/ChainsIcon.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/CheckIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import { ICopyLinkButtonProps } from './types';

import styles from './CopyLinkButton.module.scss';

export const CopyLinkButton: FC<ICopyLinkButtonProps> = ({ onClick, isLinkCopied, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <Button
      className={styles.shareLinkButton}
      startIcon={isLinkCopied ? <CheckIcon /> : <ChainsIcon />}
      variant="text"
      color="primary"
      disabled={disabled}
      onClick={onClick}
    >
      {t(isLinkCopied ? 'copiedLink' : 'copyLink')}
    </Button>
  );
};
